import okaoAxios from '../helpers/axios'
import { errorLog } from '../utils/log-helper'

/**
 * Ping session endpoint to track daily login/streak
 * Silent: logs errors but does not throw
 */
export async function pingSession(): Promise<void> {
  try {
    await okaoAxios.get('/login/session')
  } catch (error) {
    // Silent log only - no UI errors
    errorLog('Session ping failed (non-critical)', error)
  }
}

